import { render, staticRenderFns } from "./LinkedObjectChip.vue?vue&type=template&id=261e35b6"
import script from "./LinkedObjectChip.vue?vue&type=script&lang=js"
export * from "./LinkedObjectChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports